import React from 'react';
import * as S from './styles';

export default function EmptyChat() {
  return (
    <S.Container>
      <S.Icon>💬</S.Icon>
      <S.Title>Nenhuma conversa selecionada</S.Title>
      <S.Description>Selecione uma conversa para começar a enviar mensagens</S.Description>
    </S.Container>
  );
}

